(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5148],{

/***/ 5148:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ BackgroundImageWithTextButtonRightImageLeft; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/components/shared/Button/Button.jsx
var Button = __webpack_require__(8122);
// EXTERNAL MODULE: ./src/components/HomePage/BackgroundImageWithTextButtonRightImageLeft/BackgroundImageWithTextButtonRightImageLeft.module.scss
var BackgroundImageWithTextButtonRightImageLeft_module = __webpack_require__(6101);
var BackgroundImageWithTextButtonRightImageLeft_module_default = /*#__PURE__*/__webpack_require__.n(BackgroundImageWithTextButtonRightImageLeft_module);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./src/assets/images/third-bg.png
/* harmony default export */ var third_bg = ({"src":"/_next/static/media/third-bg.eb9a4535.png","height":484,"width":1920,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAA1BMVEUOGB+i94V8AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAC0lEQVR4nGNgQAcAABIAAXfx+gAAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":2});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./src/components/HomePage/BackgroundImageWithTextButtonRightImageLeft/BackgroundImageWithTextButtonRightImageLeft.jsx








function BackgroundImageWithTextButtonRightImageLeft(_ref) {
  var _ref$primaryText = _ref.primaryText,
      primaryText = _ref$primaryText === void 0 ? "" : _ref$primaryText,
      _ref$secondaryText = _ref.secondaryText,
      secondaryText = _ref$secondaryText === void 0 ? "" : _ref$secondaryText,
      _ref$buttonColor = _ref.buttonColor,
      buttonColor = _ref$buttonColor === void 0 ? "black" : _ref$buttonColor,
      _ref$buttonShape = _ref.buttonShape,
      buttonShape = _ref$buttonShape === void 0 ? "round" : _ref$buttonShape,
      footerLinks = _ref.footerLinks;

  var _useRouter = (0,router.useRouter)(),
      locale = _useRouter.locale;

  var isRtl = locale === "ar";
  var dir = isRtl ? "rtl" : "ltr";
  var ctaText = locale === "ar" ? "تواصل معنا" : "Contact us";
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (BackgroundImageWithTextButtonRightImageLeft_module_default()).container,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (BackgroundImageWithTextButtonRightImageLeft_module_default()).background,
      dir: dir,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (BackgroundImageWithTextButtonRightImageLeft_module_default())["overlay-text"],
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (BackgroundImageWithTextButtonRightImageLeft_module_default())["text-content"],
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
            className: (BackgroundImageWithTextButtonRightImageLeft_module_default())["primary-text"],
            children: primaryText
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: (BackgroundImageWithTextButtonRightImageLeft_module_default())["secondary-text"],
            children: secondaryText
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: "/contactus",
          legacyBehavior: true,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
            className: (BackgroundImageWithTextButtonRightImageLeft_module_default())["cta-link"],
            children: [ctaText, /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (BackgroundImageWithTextButtonRightImageLeft_module_default())["icon-circle"],
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
                style: {
                  transform: isRtl ? "none" : "scaleX(-1)"
                },
                width: "18",
                height: "18",
                viewBox: "0 0 18 18",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                  d: "M3.53577 3.53556L14.1424 14.1422",
                  stroke: "black",
                  strokeWidth: 1.5,
                  strokeLinecap: "round",
                  strokeLinejoin: "round"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                  d: "M3.53553 10.6066L3.53553 3.53553L10.6066 3.53553",
                  stroke: "black",
                  strokeWidth: 1.5,
                  strokeLinecap: "round",
                  strokeLinejoin: "round"
                })]
              })
            })]
          })
        })]
      })
    })
  });
}

/***/ }),

/***/ 6101:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"BackgroundImageWithTextButtonRightImageLeft_container__h34Jh","background":"BackgroundImageWithTextButtonRightImageLeft_background__036xb","overlay-text":"BackgroundImageWithTextButtonRightImageLeft_overlay-text__Om8GF","text-content":"BackgroundImageWithTextButtonRightImageLeft_text-content__WuogQ","cta-link":"BackgroundImageWithTextButtonRightImageLeft_cta-link__2OO1Z","icon-circle":"BackgroundImageWithTextButtonRightImageLeft_icon-circle__Kjt1H"};

/***/ })

}]);